var _path, _line, _line2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.51937 22C2.94396 22 2.46354 21.8073 2.07812 21.4219C1.69271 21.0365 1.5 20.556 1.5 19.9806V6.51937C1.5 5.94396 1.69271 5.46354 2.07812 5.07812C2.46354 4.69271 2.94396 4.5 3.51937 4.5H7.21625L9.52875 2H15.9713L18.2838 4.5H21.9806C22.556 4.5 23.0365 4.69271 23.4219 5.07812C23.8073 5.46354 24 5.94396 24 6.51937V19.9806C24 20.556 23.8073 21.0365 23.4219 21.4219C23.0365 21.8073 22.556 22 21.9806 22H3.51937ZM3.51937 20.75H21.9806C22.205 20.75 22.3894 20.6779 22.5338 20.5338C22.6779 20.3894 22.75 20.205 22.75 19.9806V6.51937C22.75 6.295 22.6779 6.11062 22.5338 5.96625C22.3894 5.82208 22.205 5.75 21.9806 5.75H17.7356L15.4303 3.25H10.0697L7.76437 5.75H3.51937C3.295 5.75 3.11062 5.82208 2.96625 5.96625C2.82208 6.11062 2.75 6.295 2.75 6.51937V19.9806C2.75 20.205 2.82208 20.3894 2.96625 20.5338C3.11062 20.6779 3.295 20.75 3.51937 20.75Z",
    fill: "#1C1B1F"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 12.6,
    y1: 8.23535,
    x2: 12.6,
    y2: 17.2354,
    stroke: "black",
    strokeWidth: 1.2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 12.6354,
    x2: 17,
    y2: 12.6354,
    stroke: "black",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.b7dfdbfdacd8f1b57cd8ed4034876b61.svg";
export { ForwardRef as ReactComponent };